import { ChangeDetectionStrategy, Component, inject, Input, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@recruitee/i18n';

import { IconComponent } from '../../../../../common/icon/icon.component';
import { FormFieldComponent } from '../../../../form-field/form-field.component';
import { InputComponent } from '../../../../input/input.component';
import { SEARCH_FEATURE } from '../types';
import { Select2SearchDirective } from './search.directive';

@Component({
  selector: 'rt-select2-search',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    InputComponent,
    FormFieldComponent,
    IconComponent,
    TranslatePipe,
    ReactiveFormsModule,
    Select2SearchDirective,
  ],
  template: `
    <ng-template rt-select-search>
      <div class="search-container">
        <rt-form-field (click)="$event.preventDefault()" class="context-default">
          <rt-input
            #searchQueryInput
            [autoFocus]="true"
            [hasClearButton]="true"
            [placeholder]="placeholder || ('rtu.common.search' | translate)"
            [formControl]="searchFeature.searchControl$.value"
            (reset)="searchFeature.searchControl$.value.reset()"
            variant="rounded"
          >
            <!--          (keydown)="handleSearchInputKeydown($event)"-->
            <rt-icon prefix name="search"></rt-icon>
          </rt-input>
        </rt-form-field>
      </div>
    </ng-template>
  `,
  styleUrls: ['./search-default.component.less'],
  providers: [
    {
      provide: Select2SearchDirective,
      useFactory: () => inject(Select2DefaultSearchComponent).directive,
    },
  ],
})
export class Select2DefaultSearchComponent {
  @ViewChild(Select2SearchDirective, { static: true })
  public directive: Select2SearchDirective;

  @Input() public placeholder: string;

  public searchFeature = inject(SEARCH_FEATURE);
}
